import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./filters";

import vuetify from "./plugins/vuetify";
import VuePageTitle from "vue-page-title";

import DefaultLayout from "./layouts/Default";

Vue.component("DefaultLayout", DefaultLayout);

Vue.use(VuePageTitle, {
  suffix: "- Rehab Admin",
}); // https://github.com/vinicius73/vue-page-title

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
